export function convertBytes(bytes: number) {
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB"];
    let i = 0;
    while (bytes >= 1024) {
        bytes /= 1024;
        i++;
    }
    return `${bytes.toFixed(2)} ${sizes[i]}`;
}
